<template>
  <b-navbar-nav class="exchange-rate-area">
    <b-nav-text class="exchange-rate-margin">{{date}}</b-nav-text>
    <b-nav-text class="exchange-rate-margin">{{name}}</b-nav-text>
    <b-nav-text class="exchange-rate-margin">{{price}}</b-nav-text>
  </b-navbar-nav>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      name: '',
      date: '',
      time: '',
      price: '',
    };
  },
  created() {
    this.update();
    // setInterval(() => {
    //     this.update();
    // }, 1000 * 1 * 30);
  },
  methods: {
    update() {
      const item = api.getExchangeRate('USDJPY', (item) => {
        this.name = this.$i18n.t('exchangeRate.' + item['id']);
        this.date = utility.formatDate(item['date'], 'MM月dd日');
        this.time = item['time'];
        this.price = item['price'];
      });
    },
  }
};
</script>

<style>
.exchange-rate-area {
  background-color: #404040;
  margin-left: 3rem;
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  user-select: none;
}
.exchange-rate-margin {
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}
</style>